// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"3be2a9a6","363":"408ac16b","875":"b37fad64"}[chunkId] + ".chunk.js";
};